import React from 'react';
import DirectionProvider, { DIRECTIONS } from 'react-with-direction/dist/DirectionProvider';
import { ImgProvider, RENDER_IMAGE_WITH_PLACEHOLDER_INITIALLY } from '@wix/communities-image-lib';
import RuntimeContext from '../../../common/components/runtime-context';
import RecentPostsWidget from '../widget';
import { PermissionsContextProvider } from '../../../common/components/permissions-context';
import { getCategory } from '../../../common/selectors/categories-selectors';
import { getLanguage } from '../../../common/store/basic-params/basic-params-selectors';
import { isWebpSupported } from '@wix/communities-forum-client-commons/dist/src/services/is-webp-supported';
import { getTranslations } from '../../../common/store/translations/translations-selectors';
import { usePromisifiedAction } from '../../../common/actions-promisifier/use-promisified-action';
import {
  initI18n as initI18nICU,
  I18nextProvider as I18nextProviderICU,
} from '@wix/wix-i18n-config';
import { icuOptions } from '../../../common/constants/icu-options';

const permissionsResourceResolver = state => resource => {
  if (resource.categoryId) {
    resource = getCategory(state, resource.categoryId);
  }
  return resource;
};

class RecentPostsWidgetRoot extends React.Component {
  getI18nConfigICU = (language, translations) => {
    if (this.lastLanguage !== language || !this.i18nConfigICU) {
      this.i18nConfigICU = initI18nICU({
        locale: language,
        messages: translations,
        icuOptions,
      });

      this.lastLanguage = language;
    }
    return this.i18nConfigICU;
  };

  render() {
    const { actions, actionsPromisified, host, isRTL, ...rest } = this.props;
    const state = this.props;
    const lang = getLanguage(state);
    const translations = getTranslations(state);
    const i18nICU = this.getI18nConfigICU(lang, translations);

    const connectedActionsPromisified = Object.keys(actionsPromisified).reduce(
      (wrapped, actionName) => {
        wrapped[actionName] = usePromisifiedAction(actionsPromisified[actionName], state);
        return wrapped;
      },
      {},
    );

    return (
      <RuntimeContext.Provider
        value={{
          state,
          actions: { ...actions, ...connectedActionsPromisified },
          host: host || rest,
        }}
      >
        <PermissionsContextProvider state={state} resourceResolver={permissionsResourceResolver}>
          <DirectionProvider direction={isRTL ? DIRECTIONS.RTL : DIRECTIONS.LTR}>
            <ImgProvider
              renderMode={RENDER_IMAGE_WITH_PLACEHOLDER_INITIALLY}
              format={isWebpSupported() ? 'webp' : 'png'}
            >
              <I18nextProviderICU i18n={i18nICU}>
                <RecentPostsWidget />
              </I18nextProviderICU>
            </ImgProvider>
          </DirectionProvider>
        </PermissionsContextProvider>
      </RuntimeContext.Provider>
    );
  }
}

export default RecentPostsWidgetRoot;
